/*
Item: Timer components for automatic log-off
Name: Clock
Format: Code component
*/

import React, { Component } from 'react';
import MessageService from '../service/MessageService';

export default class Clock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seconds: this.props.seconds || 0,
      time: { m: 0, s: 0 },
      show: false,
    };
    this.timer = 0;
    this.convertSeconds = this.convertSeconds.bind(this);
    this.countDown = this.countDown.bind(this);
    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);
    this.messageService = new MessageService();
  }

  // formats seconds to minutes:seconds for display purposes
  convertSeconds(secondsRemaining) {
    let minutes = Math.floor(secondsRemaining / 60);
    // let seconds = secondsRemaining - (minutes * 60);
    let seconds = secondsRemaining - minutes * 60;
    let time = {
      m: minutes,
      s: seconds < 10 ? '0' + seconds : seconds,
    };
    return time;
  }

  // counts the seconds down, clears interval if seconds are 0 or below and logs user out
  countDown() {
    // console.log("counting");
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.convertSeconds(seconds),
      seconds: seconds,
    });
    if (seconds <= 0) {
      clearInterval(this.timer);
      this.messageService.postUserLogout(sessionStorage.getItem('logoutId'));
    }
  }

  // Starts the clock, interval calls countDown method every 1000ms
  start() {
    this.setState({
      seconds: this.props.seconds,
      time: this.convertSeconds(this.props.seconds),
      show: true,
    });
    this.timer = setInterval(this.countDown, 1000);
  }

  // stops the clock, clears the interval, hides time display
  stop() {
    clearInterval(this.timer);
    this.setState({
      show: false,
    });
  }

  // renders the time display if state is set to show
  render() {
    const { show, time } = this.state;
    return show ? (
      <span>
        Abmeldung in:&ensp;
        {time.m}
        :
        {time.s}
      </span>
    ) : (
      ''
    );
  }
}
